import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { newLivePublished, updateEndLive } from "../../redux/lives/livesSlice";
import {
  getConversationById,
  getConversationsAfterMediaPush,
  handleConversationTypeChange,
  handleEditMessage,
  handleNewMessageData,
  handleNextUndeliveredMessageChange,
  removeFromUnanswered,
  updateConversationHasNewMessages,
  updateConversations,
  updateUnreadConversations,
} from "../../redux/messages/messagesSlice";
import { AppDispatch, StoreState } from "../../redux/store";
import { authService, messageService } from "../../services";
import { socket } from "../../socket";
import { C_CURRENT_TAB, CONVERSATION_TYPES } from "../constant";
import { IConversationDTO, IMessage, ISwitchConversationType, ISwitchUndeliveredMessage } from "../types";
import { useSelector } from "react-redux";

export const MessagesInterceptor = () => {
  const dispatch = useDispatch<AppDispatch>();
  const shouldFetch = useRef(true);
  const { selectedConversation } = useSelector((state: StoreState) => state.messages);
  useEffect(() => {
    if (authService.isAuthenticated() && shouldFetch.current) {
      shouldFetch.current = false;
      messageService.getTotalNotReadMessages().then((total) => {
        if (total && total !== "") {
          dispatch(updateUnreadConversations(parseInt(total, 10)));
        }
      });
    }
  }, []);

  useEffect(() => {
    socket.on("message", handleMessage);
    socket.on("conversation-created", handleConversationCreated);
    socket.on("update-message", handleUpdateMessage);
    socket.on("switch-conversation-type", handleSwitchConversationType);
    socket.on("switch-next-message-to-deliver", handleSwitchToNextUndeliveredMessage);
    socket.on("streams_updated", streamLiveUpdated);
    socket.on("mediaPush-sent", handleConversationsAfterMediaPush);
    socket.on("notify-read-messages-in-conversation", handleUpdateUnreadConversations);

    return () => {
      socket.off("message", handleMessage);
      socket.off("conversation-created", handleConversationCreated);
      socket.off("update-message", handleUpdateMessage);
      socket.off("switch-conversation-type", handleSwitchConversationType);
      socket.off("switch-next-message-to-deliver", handleSwitchToNextUndeliveredMessage);
      socket.off("streams_updated", streamLiveUpdated);
      socket.off("mediaPush-sent", handleConversationsAfterMediaPush);
      socket.off("notify-read-messages-in-conversation", handleUpdateUnreadConversations);
    };
  }, []);

  useEffect(() => {
    socket.on("conversation-updated", handleConversationUpdated);

    return () => {
      socket.off("conversation-updated", handleConversationUpdated);
    };
  }, [selectedConversation]);

  function handleMessage(data: any) {
    dispatch(
      updateConversationHasNewMessages({
        conversationId: data.conversationId,
        createdAt: data.createdAt,
        conversationType: data.conversationType,
        isReceiver: data.isReceiver,
        lastMessage: data.text,
      })
    );

    if (data.senderId === authService.getId()) {
      dispatch(
        removeFromUnanswered({
          conversationId: data.conversationId,
          type: data.conversationType,
        })
      );
    }
    dispatch(handleNewMessageData(data));
  }

  function handleConversationCreated(data: IConversationDTO) {
    dispatch(updateConversations(data));
  }

  function handleUpdateMessage(data: IMessage) {
    dispatch(handleEditMessage(data));
  }

  function handleSwitchConversationType(data: ISwitchConversationType) {
    dispatch(handleConversationTypeChange(data));
  }

  function handleSwitchToNextUndeliveredMessage(data: ISwitchUndeliveredMessage) {
    dispatch(handleNextUndeliveredMessageChange(data));
  }

  function handleConversationUpdated(data: IConversationDTO) {
    if (data._id === selectedConversation._id) {
      socket.emit("read-all-messages", selectedConversation._id);
    }
    dispatch({
      type: getConversationById.fulfilled.type,
      payload: data,
    });
  }

  const streamLiveUpdated = (data: any) => {
    if (data?.isNewStream && data?.stream) {
      dispatch(newLivePublished(true));
    }
    if (data?.isStreamingEnds && data?.streamId) {
      dispatch(updateEndLive({ streamId: data?.streamId, isStreamingEnds: data?.isStreamingEnds }));
    }
  };

  const handleConversationsAfterMediaPush = (data: any) => {
    //dispatch(clearAllConversations());
    dispatch(getConversationsAfterMediaPush({ page: 1, type: window.localStorage.getItem(C_CURRENT_TAB) || CONVERSATION_TYPES.SUBSCRIPTION }));
  };

  const handleUpdateUnreadConversations = (data: number) => {
    dispatch(updateUnreadConversations(data));
  };

  return <></>;
};
